<template>
  <div class="mobile-wallet-card">
    <div
      v-if="$store.getters.canMemberDeposit"
      id="m-deposit"
      class="wallet-list"
      @click="$router.push('/deposit')"
    >
      {{ $t('Bao.deposit') }}
    </div>
    <div
      v-if="$store.getters.canMemberDeposit"
      id="m-crypto-buy"
      class="wallet-list"
      @click="$router.push('/deposit?mode=buy')"
    >
      {{ $t('Bao.buy_cryptocurrency') }}
    </div>
    <div
      id="m-withdraw"
      :class="!isCryptoExchange ? 'wallet-list-on' : 'wallet-list'"
      @click="isCryptoExchange && $emit('toggle-mode')"
    >
      {{ $t('Bao.withdraw_menu') }}
    </div>
    <div
      v-if="!$store.getters.isOfflineAgentMember"
      id="m-crypto-exchange"
      :class="isCryptoExchange ? 'wallet-list-on' : 'wallet-list'"
      @click="!isCryptoExchange && $emit('toggle-mode')"
    >
      {{ $t('Bao.crypto_exchange') }}
    </div>
  </div>
</template>

<script>
import themeMixin from '@/mixins/themeMixin'

export default {
  name: 'WithdrawTabNav',
  mixins: [themeMixin],
  props: {
    isCryptoExchange: {
      type: Boolean,
      default: false
    }
  }
}
</script>
